import React from 'react';
import { StarIcon, PlayIcon, LightbulbIcon, HandIcon, ShieldCheckIcon } from 'lucide-react';
export function TemplateShortPage() {
  return <div className="min-h-screen w-full bg-[#f8f7f4] font-sans text-[#1e293b] selection:bg-[#b91c1c] selection:text-white" data-id="element-1895">
      {/* 1. Top Nav Bar */}
      <header className="bg-[#002868] text-white w-full" data-id="element-1896">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-12 flex items-center justify-between" data-id="element-1897">
          <div className="flex items-center gap-2 font-bold text-lg tracking-tight" data-id="element-1898">
            <StarIcon className="w-5 h-5 fill-current text-[#b91c1c]" data-id="element-1899" />
            <span data-id="element-1900">PatriotsInformer News</span>
          </div>
          <nav className="hidden sm:flex items-center gap-6 text-sm font-medium" data-id="element-1901">
            <a href="#" className="hover:text-gray-200 transition-colors" data-id="element-1902">
              Home
            </a>
            <a href="#" className="hover:text-gray-200 transition-colors" data-id="element-1903">
              About Us
            </a>
            <a href="#" className="hover:text-gray-200 transition-colors" data-id="element-1904">
              Contact
            </a>
          </nav>
        </div>
      </header>

      {/* 2. Breadcrumb Bar */}
      <div className="bg-white border-b border-gray-200 w-full" data-id="element-1905"></div>

      {/* Main Content Area */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12 space-y-12" style={{
      paddingTop: '2px'
    }} data-id="element-1906">
        {/* 3. Article Section */}
        <article className="space-y-6" data-id="element-1907">
          {/* Title & Meta */}
          <div className="space-y-2" data-id="element-1908">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0f172a] tracking-tight leading-tight" data-id="element-1909">
              How to Secure Your Water Supply for Life
            </h1>
            <p className="text-sm text-gray-500 font-medium" data-id="element-1910">
              <span className="text-[#002868] font-bold" data-id="element-1911">Jack Turner</span> ·
              March 26, 2026
            </p>
          </div>

          {/* Video Placeholder */}
          <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden shadow-xl group cursor-pointer" data-id="element-1912">
            <img src="https://images.unsplash.com/photo-1538300342682-cf57afb97285?q=80&w=2574&auto=format&fit=crop" alt="Video thumbnail" className="w-full h-full object-cover opacity-80 group-hover:opacity-60 transition-opacity" data-id="element-1913" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-1914">
              <div className="w-20 h-20 bg-[#b91c1c] rounded-xl flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300" data-id="element-1915">
                <PlayIcon className="w-10 h-10 text-white fill-current ml-1" data-id="element-1916" />
              </div>
            </div>
            <div className="absolute bottom-4 left-4 bg-black/70 px-3 py-1 rounded text-white text-sm font-medium flex items-center gap-2" data-id="element-1917">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-1918"></span>
              Watch Now
            </div>
          </div>

          {/* CTA Callout Box - Replicating the dashed border style */}
          <div className="mt-12 border-4 border-dashed border-[#b91c1c] bg-yellow-50 p-6 sm:p-8 rounded-lg relative" data-id="element-1919">
            <div className="space-y-4" data-id="element-1920">
              <div className="flex items-start gap-3" data-id="element-1921">
                <LightbulbIcon className="w-6 h-6 text-yellow-600 fill-current flex-shrink-0 mt-1" data-id="element-1922" />
                <h3 className="text-xl font-bold text-[#0f172a]" data-id="element-1923">
                  Want a simple, step-by-step way to do this yourself?
                </h3>
              </div>

              <p className="text-[#334155] text-lg leading-relaxed pl-9" data-id="element-1924">
                The DIY Biosand System walks through the exact process — from
                choosing materials to filtering water safely — without
                overwhelm.
              </p>

              <div className="pl-9 pt-2" data-id="element-1925">
                <a href="#" className="inline-flex items-center gap-2 text-[#002868] font-bold text-xl hover:underline decoration-2 underline-offset-4" data-id="element-1926">
                  <span className="text-2xl" data-id="element-1927">👉</span>
                  View the DIY Biosand System Guide
                </a>
              </div>
            </div>
          </div>
        </article>

        {/* 4. 'You Might Also Like' Section */}
        <section className="space-y-8 pt-8 border-t border-gray-200" data-id="element-1928">
          <h2 className="text-3xl font-bold text-[#0f172a]" data-id="element-1929">
            You Might Also Like:
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8" data-id="element-1930">
            {/* Card 1 */}
            <div className="group cursor-pointer space-y-3" data-id="element-1931">
              <div className="aspect-[4/3] overflow-hidden rounded-lg shadow-md" data-id="element-1932">
                <img src="https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?q=80&w=2670&auto=format&fit=crop" alt="Solar panel setup" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1933" />
              </div>
              <h3 className="font-bold text-lg text-[#0f172a] leading-tight group-hover:text-[#002868] transition-colors" data-id="element-1934">
                Complete Off-Grid Power for Under $500!
              </h3>
            </div>

            {/* Card 2 */}
            <div className="group cursor-pointer space-y-3" data-id="element-1935">
              <div className="aspect-[4/3] overflow-hidden rounded-lg shadow-md" data-id="element-1936">
                <img src="https://images.unsplash.com/photo-1615811361269-669243c15853?q=80&w=2574&auto=format&fit=crop" alt="Vegetable garden" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1937" />
              </div>
              <h3 className="font-bold text-lg text-[#0f172a] leading-tight group-hover:text-[#002868] transition-colors" data-id="element-1938">
                Wanted: Grow These 5 Survival Foods at Home
              </h3>
            </div>

            {/* Card 3 */}
            <div className="group cursor-pointer space-y-3" data-id="element-1939">
              <div className="aspect-[4/3] overflow-hidden rounded-lg shadow-md" data-id="element-1940">
                <img src="https://images.unsplash.com/photo-1595273240280-dd15d8dd726d?q=80&w=2574&auto=format&fit=crop" alt="Man holding tools" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1941" />
              </div>
              <h3 className="font-bold text-lg text-[#0f172a] leading-tight group-hover:text-[#002868] transition-colors" data-id="element-1942">
                Turn Scrap Metal Into Cash (Watch Video)
              </h3>
            </div>
          </div>
        </section>
      </main>

      {/* 5. Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12 py-12" data-id="element-1943">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-6" data-id="element-1944">
          <div className="flex items-center justify-center gap-2 text-[#b91c1c]" data-id="element-1945">
            {/* Simple Logo Graphic */}
            <div className="relative w-10 h-10" data-id="element-1946">
              <StarIcon className="w-10 h-10 fill-current text-[#002868]" data-id="element-1947" />
              <StarIcon className="w-4 h-4 fill-current text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-1948" />
            </div>
          </div>

          <div className="text-xs text-gray-500 space-y-4 max-w-2xl mx-auto leading-relaxed" data-id="element-1949">
            <p data-id="element-1950">
              © 2018-2026 PatriotsInformer Media, LLC | All Rights Reserved |
              10160 Highway 242 Ste 800 PMB 1089, Conroe, TX 77385
            </p>
            <p className="space-x-2" data-id="element-1951">
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1952">
                Terms & Conditions
              </a>
              <span data-id="element-1953">|</span>
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1954">
                Privacy Policy
              </a>
              <span data-id="element-1955">|</span>
              <a href="#" className="underline hover:text-[#002868]" data-id="element-1956">
                Contact Us
              </a>
            </p>
            <p data-id="element-1957">
              No part of this report may be reproduced or placed on any
              electronic medium without written permission from the publisher.
              Information contained herein is obtained from sources believed to
              be reliable, but its accuracy cannot be guaranteed.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}